import 'antd/dist/antd.compact.css'
import 'antd-button-color/dist/css/style.css';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Flex from "./core/components/Flex";
import MoonLoader from "react-spinners/MoonLoader";
import { ModalProvider } from "./core/context/ModalContext";
import Modal from "./core/components/Modal";
import PatientRouter from "./PatientRouter";

export default function PatientApp() {

    return (
        <>
            <div
                id={'request-spinner'}
                style={{
                    display: 'none',
                    position: 'fixed',
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#00000020',
                    zIndex: 9999
                }}
            >
                <Flex style={{ height: '100%' }} flexDirection={'column'} justifyContent={'center'} alignItems={'center'} justifyItems={'center'}>
                    <MoonLoader color={'#0000ff'} size={80} />
                </Flex>
            </div>
            <div className="App">
                <ModalProvider>
                    <PatientRouter />
                    <Modal />
                </ModalProvider>

                <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>
        </>
    )
}
